import { useMemo } from "react";
import { useParams } from "react-router-dom";

import { useMainTabs } from "@/hooks";
import { ContentSubNav, ContentTab } from "@/app/modules/ContentTab";
import { ErrorPage } from "@/components";
import { Header } from "@/app/modules/Navigation";
import { isContentTemplate } from "@/utils";

export const Content = () => {
  const { tabId, subTabId } = useParams();
  const { mainTabs } = useMainTabs();

  const tab = useMemo(() => {
    if (!mainTabs || mainTabs.length === 0) {
      return undefined;
    }
    if (!tabId) {
      const sortedTabs = [...mainTabs].sort((a, b) => a.Position - b.Position);
      return (
        sortedTabs.find(
          (t) => isContentTemplate(t.TemplateId) || t.TemplateId === "22",
        ) ?? sortedTabs[0]
      );
    }
    return mainTabs?.find((t) => t.TabId == parseInt(tabId));
  }, [tabId, mainTabs]);

  if (mainTabs && !tab) {
    return <ErrorPage code={404} />;
  }

  if (tab && tab?.TemplateId === "22") {
    // Default to first subtab
    if (!subTabId) {
      const subTabId = tab.Items[0].ChildId;
      return <ContentSubNav tabId={tab.TabId.toString()} subTabId={subTabId} />;
    }

    // Open the specified subtab from the URL
    return <ContentSubNav tabId={tab.TabId.toString()} subTabId={subTabId} />;
  }

  const isMainTab = !!tab;
  return (
    <div>
      <Header
        className="px-[28px]"
        content={isMainTab ? <div></div> : undefined}
      />
      <ContentTab id={tab?.TabId ?? 0} />
    </div>
  );
};
``;
